(() => {
 function init(){
  if(document.body.classList.contains('collection')){
   const url=new URL(location.href);let changed=false;
   for(const key of [...url.searchParams.keys()])if(key.startsWith('filter.')&&key!=='filter.v.availability'){url.searchParams.delete(key);changed=true}
   if(url.searchParams.get('filter.v.availability')!=='1'){url.searchParams.set('filter.v.availability','1');changed=true}
   if(changed){url.searchParams.delete('page');location.replace(url.href);return}
  }
  document.querySelectorAll('a[href]').forEach(a=>{
   try{const u=new URL(a.href);if(u.origin===location.origin&&u.pathname.startsWith('/collections/')&&u.pathname.split('/').length===3){u.searchParams.set('filter.v.availability','1');a.href=u.href}}catch{}
  });
  const dialog=document.getElementById('sw-mobile-menu'),opener=document.querySelector('[data-sw-menu-open]');
  if(dialog && !dialog.dataset.ready){
   dialog.dataset.ready='1';
   const close=()=>dialog.close();
   opener?.addEventListener('click',()=>{dialog.showModal();opener.setAttribute('aria-expanded','true');document.documentElement.classList.add('sw-menu-open')});
   dialog.querySelector('[data-sw-menu-close]')?.addEventListener('click',close);
   dialog.addEventListener('click',e=>{if(e.target===dialog){const r=dialog.getBoundingClientRect();if(e.clientX>r.right||e.clientY>r.bottom)close()}});
   dialog.addEventListener('close',()=>{opener?.setAttribute('aria-expanded','false');document.documentElement.classList.remove('sw-menu-open');opener?.focus()});
   matchMedia('(min-width:981px)').addEventListener('change',e=>{if(e.matches&&dialog.open)close()});
  }
  document.querySelectorAll('[data-sw-price-range]').forEach(group=>{
   if(group.dataset.ready)return;group.dataset.ready='1';
   const low=group.querySelector('[data-range-low]'),high=group.querySelector('[data-range-high]'),currency=group.dataset.currency||'EUR';
   const money=new Intl.NumberFormat('de-DE',{style:'currency',currency});
   function update(changed){
    if(Number(low.value)>Number(high.value)){if(changed===low)high.value=low.value;else low.value=high.value}
    group.querySelector('[data-price-low]').textContent=money.format(Number(low.value));
    group.querySelector('[data-price-high]').textContent=money.format(Number(high.value));
    const max=Number(high.max)||1,track=group.querySelector('.sw-range-track');
    track.style.setProperty('--low',`${Number(low.value)/max*100}%`);track.style.setProperty('--high',`${Number(high.value)/max*100}%`);
    low.style.zIndex=Number(low.value)>max*.9?'4':'2';
   }
   low.addEventListener('input',()=>update(low));high.addEventListener('input',()=>update(high));update();
  });
 }
 init();document.addEventListener('shopify:section:load',init);
})();
